import { render, staticRenderFns } from "./patientPortalCreateLogin.vue?vue&type=template&id=4f06cf6e&"
import script from "./patientPortalCreateLogin.vue?vue&type=script&lang=js&"
export * from "./patientPortalCreateLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports